import React from 'react';

import { connect } from 'react-redux';
import { QRCodeSVG } from 'qrcode.react';
import Cookies from 'js-cookie';

import colors from '../util/colors';
import { VERSION, getLogsFlag, setLogsFlag, fireAnalytics } from './utils';

// Actions
import { deleteDevice } from '../store/actions/deviceActions';
import { clearFeaturedPlaylist, clearUserPlaylists, clearActivePlaylist } from '../store/actions/playlistActions';
import { clearUser } from '../store/actions/userActions';
import { clearSubscription } from '../store/actions/subscriptionActions';
import { DELETE_DEVICE_SUCCESS } from '../store/constants/deviceConstants';

import { LEFT, RIGHT, BACK, ENTER, UP, DOWN } from '../util/remoteButtons';
import { withNavigate } from '../util/withNavigate';

export class Account extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logs: getLogsFlag(),
      logsTextVisibilty: false,
      clearCache: false,
      styles: this.getStyles(),
    };
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.selectedBtn = 'Back';
    this.enableLogs = 0;
    this.logsTimeout = null;
    this.logsText = '';
  }

  componentDidMount() {
    fireAnalytics('Page', 'Account Page Loaded');
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    var backButton = this.refs.backButton;
    backButton && backButton.focus();
  }

  goToPage = (pageLink) => {
    const { navigate } = this.props;
    navigate(pageLink);
  };

  handleKeyDown(e) {
    e.stopPropagation();
    if (e.which === 38 || e.which === 40) {
      if (this.logsTimeout !== null) {
        clearTimeout(this.logsTimeout);
      }
      if (this.enableLogs === 76 && e.which !== 40) this.enableLogs = 0;
      this.enableLogs = this.enableLogs + e.which;
      if (this.enableLogs === 154) {
        if (this.state.logs) {
          this.logsText = 'Player Logs Disabled';
          this.setState({ logsTextVisibilty: true });
          setTimeout(() => {
            this.setState({ logsTextVisibilty: false });
          }, 3000);
          setLogsFlag(false);
          this.setState({ logs: false });
        } else {
          setLogsFlag(true);
          this.setState({ logs: true });
          this.logsText = 'Player Logs Enabled';
          this.setState({ logsTextVisibilty: true });
          setTimeout(() => {
            this.setState({ logsTextVisibilty: false });
          }, 3000);
        }
        this.enableLogs = 0;
      }
      this.logsTimeout = setTimeout(() => {
        this.enableLogs = 0;
      }, 7000);
    } else {
      this.enableLogs = 0;
    }
    switch (e.which) {
      case RIGHT:
        if (this.state.clearCache) {
          document.getElementById('No').style.background = '';
          document.getElementById('yes').style.background = '#910048';
          this.selectedBtn = 'Yes';
        } else {
          if (this.selectedBtn === 'Back') {
            this.selectedBtn = 'Logout';
          } else if (this.selectedBtn === 'Logout') {
            this.selectedBtn = 'Clear';
          }
        }
        break;
      case LEFT:
        if (this.state.clearCache) {
          document.getElementById('yes').style.background = '';
          document.getElementById('No').style.background = '#910048';
          this.selectedBtn = 'No';
        } else {
          if (this.selectedBtn === 'Logout') {
            this.selectedBtn = 'Back';
          } else if (this.selectedBtn === 'Clear') {
            this.selectedBtn = 'Logout';
          }
        }
        break;
      case ENTER:
        if (this.state.clearCache) {
          if (this.selectedBtn === 'No') {
            this.setState({ clearCache: false });
            setTimeout(() => {
              this.selectedBtn = 'Clear';
            }, 200);
          }
          if (this.selectedBtn === 'Yes') {
            // window.open("", "_self").close();
            // this.goToPage('/');
            this.removeAllDownloads();
          }
        } else {
          if (this.selectedBtn === 'Back') {
            this.props.history.goBack();
          } else if (this.selectedBtn === 'Logout') {
            fireAnalytics('User', 'Logged Out', this.props.user.data.user ? this.props.user.data.user.email : '');
            this.logout();
          } else if (this.selectedBtn === 'Clear') {
            setTimeout(() => {
              var no = this.refs.no;
              no && no.focus();
            }, 200);
            this.setState({ clearCache: !this.state.clearCache });
          } else if (this.selectedBtn === 'Reset'){
            console.log("Resetting device id");
            this.resetId();
          }
        }
        break;
      case UP:
        if (!this.state.clearCache) {
          if (this.selectedBtn === 'Reset') {
            this.selectedBtn = 'Back';
          }
        }
      case DOWN:
        if (!this.state.clearCache) {
          if (this.selectedBtn !== 'Reset') {
            this.selectedBtn = 'Reset';
          }
        }
      case 27: /////////////////For Esc Keyboard Key
      case BACK:
        this.props.history.goBack();
        break;
    }
  }
 
  /*removeAllDownloads() {
    const that = this;
    var successCb = function (cbObject) {
      // console.log('Removed all files Internal');
      that.setState({ clearCache: false });
      that.goToPage('/');
    };

    var failureCb = function (cbObject) {
      var errorCode = cbObject.errorCode;
      var errorText = cbObject.errorText;
      // console.log(' Error Code [' + errorCode + ']: ' + errorText);
    };
    let path = 'internal';
    if (window.isUSB) path = 'usb:1/';
    var options = {
      device: path, // This will remove all the files in the local storage.
    };

    var storage = new Storage();
    storage.removeAll(successCb, failureCb, options);
  }*/

  logout = async () => {
    try {
      const response = await this.props.deleteDevice(this.props.device.data.id);
      this.props.clearFeaturedPlaylist();
      this.props.clearUserPlaylists();
      this.props.clearActivePlaylist();
      this.props.clearUser();
      this.props.clearSubscription();
      localStorage.removeItem('DeviceID');
      Cookies.remove('auth__token');
      if (response.errors === 'Error') {
        setTimeout(() => {
          this.goToPage('/error');
        }, 10);
        return;
      }
      if (response.type === DELETE_DEVICE_SUCCESS) {
        this.goToPage('/');
      }
    } catch (e) {
      // console.log(e);
    }
  };

  resetId = async () => {
    try {
      const response = await this.props.deleteDevice(this.props.device.data.id);
      localStorage.removeItem('DeviceID');
      if (response.errors === 'Error') {
        setTimeout(() => {
          this.goToPage('/error');
        }, 10);
        return;
      }
      if (response.type === DELETE_DEVICE_SUCCESS) {
        this.goToPage('/');
      }
    } catch (e) {
      // console.log(e);
    }
  };

  getStyles = () => {
    const isPortrait = window.innerWidth <= window.innerHeight;
    return {
      paddingTop: isPortrait ? '50%' : '100px'
    };
  };

  handleResize = () => {
    this.setState({ styles: this.getStyles() });
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    const { styles } = this.state;
    return (
      <div className="Wrapper">
        {this.state.clearCache ? (
          <div
            id="models"
            className="reg-response-modal"
            onKeyDown={this.handleKeyDown}
            style={{ position: 'absolute', zIndex: '9999' }}
          >
            <div
              className="model"
              style={{ width: '40%', backgroundColor: 'black', color: 'white', borderRadius: '15px' }}
            >
              <img
                className="Logo2"
                src="assets/img/blackdove-logo-2020.png"
                alt=""
                style={{ width: '50%', paddingTop: '6%' }}
              />
              <h2 style={{ marginBottom: '2%', fontSize: '2em', padding: '0 1em' }}>
                Do you want to clear device cache and reload app?
              </h2>
              <button
                ref="no"
                id="No"
                style={{
                  padding: '2%',
                  float: 'left',
                  width: '30%',
                  fontSize: '2em',
                  marginBottom: '6%',
                  marginLeft: '14%',
                  marginTop: '4%',
                  fontWeight: '600',
                  background: '#910048',
                }}
              >
                No
              </button>
              <button
                ref="yes"
                id="yes"
                style={{
                  padding: '2%',
                  float: 'right',
                  width: '30%',
                  fontSize: '2em',
                  marginBottom: '6%',
                  marginRight: '18%',
                  marginTop: '4%',
                  fontWeight: '600',
                }}
              >
                Yes
              </button>
            </div>
          </div>
        ) : null}
        <div
          className="InfoWrapper"
          onKeyDown={this.handleKeyDown}
          style={{ paddingTop: styles.paddingTop}}
        >
          <img className="Logo2" src="assets/img/blackdove-logo-2020.png" alt="" />
          <span className="Info">
            Go to https://account.blackdove.com to change
            <br />
            your account details and edit your subscription.
          </span>
          <div className="DetailsWrapper" style={{ borderTop: `1px solid ${colors.lighterBase}` }}>
            <div className="DetailLabel">Account:</div>
            <div className="DetailLabel">{this.props.user.data.user ? this.props.user.data.user.email : ''}</div>
          </div>
          <div className="DetailsWrapper">
            <div className="DetailLabel">Subscription:</div>
            <div className="DetailLabel">{this.props.subscription.data.plan ? this.props.subscription.data.plan.description : ''}</div>
          </div>
          <div
            className="DetailsWrapper"
            style={{ borderBottom: `1px solid ${colors.lighterBase}`, marginBottom: '40px' }}
          >
            <div className="DetailLabel">Device Id:</div>
            <div className="DetailLabel">{this.props.app.SCAPDeviceId}</div>
          </div>
          <div>
            <div className="row row--push-btm-xs">
              <div className="col-3" style={{ padding: '0', marginRight: '1em' }}>
                <div
                  ref="backButton"
                  tabIndex="6"
                  className="btn btn--round btn--block btn--dark info__btn pull-left "
                  style={{ background: '#910048' }}
                  onClick={() => this.props.history.goBack()}
                >
                  Back
                </div>
              </div>
              <div className="col-3" style={{ padding: '0', marginRight: '1em' }}>
                <div
                  tabIndex="7"
                  ref="logout"
                  className="btn btn--round btn--dark pull-right info__btn"
                  style={{ background: '#910048' }}
                  onClick={() => this.logout()}
                >
                  Logout
                </div>
              </div>
              <div className="col-5" style={{ padding: '0' }}>
                <div
                  ref="clear"
                  tabIndex="6"
                  className="btn btn--round btn--block btn--dark info__btn pull-left "
                  style={{ background: '#910048' }}
                >
                  Clear Storage
                </div>
              </div>
            </div>
            <div className="row row--push-btm-xs">
              <div className="col-3" style={{ padding: '0', marginRight: '1em' }}>
                <div
                  ref="resetBtn"
                  tabIndex="6"
                  className="btn btn--round btn--block btn--dark info__btn pull-left "
                  style={{ background: '#910048' }}
                  onClick={() => this.resetId()}
                >
                  Reset Player ID
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="QRWrapper">
          <QRCodeSVG
            value={this.props.app.SCAPDeviceId}
            size={180}
          />
        </div>
        <div className="VersionWrapper">{`v ${VERSION}`}</div>
        <div className="timedPopup" style={!this.state.logsTextVisibilty ? { opacity: '0' } : { opacity: '1' }}>
          {this.logsText}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  deleteDevice: (deviceId) => dispatch(deleteDevice(deviceId)),
  clearFeaturedPlaylist: () => dispatch(clearFeaturedPlaylist()),
  clearUserPlaylists: () => dispatch(clearUserPlaylists()),
  clearActivePlaylist: () => dispatch(clearActivePlaylist()),
  clearUser: () => dispatch(clearUser()),
  clearSubscription: () => dispatch(clearSubscription()),
});

export default connect((state) => {
  const { app, activePlaylist, device, user, subscription } = state;
  return {
    app,
    device,
    user,
    subscription,
    activePlaylist,
  };
}, mapDispatchToProps)(withNavigate(Account));
